const axios = require('axios')
import getCookie from '@/service/getCookie'
import deleteCookie from '@/service/deleteCookie'
import store from '../desktop/stores'
import { commonMixin } from '../mixins/common'

const axiosFormData = async (method, url, data = null, resType = null, debugMsg = '') => {
  let option = {
    'Content-Type': 'multipart/form-data',
    'x-api-host': 'mycrm',
  }
  
  let x_api_key = getCookie('api-keys') ? JSON.parse(getCookie('api-keys'))[0] : '';
  if (x_api_key) {
    option['x-api-key'] = x_api_key
  }
  /*20250808配合滲透測試弱點移除header中x-id
  if (data && data.header && data.header.userId) {
    option['x-id'] = data.header.userId
  }
  */
  let API_BASEURL = 'http://localhost:8081/MXWeb'
  let BFF_API_BASEURL = window.location.origin;
  if(window.location.href.indexOf('localhost') !== -1){
    API_BASEURL = 'http://localhost:8081/MXWeb'
    BFF_API_BASEURL = `http://localhost:8088`
  }else if(window.location.href.indexOf('tmycrm') !== -1){
    API_BASEURL = 'https://tcrmapi.cathaylife.com.tw/MXWeb'
  }else if(window.location.href.indexOf('smycrm') !== -1){
    API_BASEURL = 'https://scrmapi.cathaylife.com.tw/MXWeb'
  }else if(window.location.href.indexOf('mycrm') !== -1){
    API_BASEURL = 'https://crmapi.cathaylife.com.tw/MXWeb'
  }else{
    API_BASEURL = `http://${window.location.href.match(/\d*\.\d*\.\d*\.\d*/g)}:8081/MXWeb`
  }
  let apiUrl = `${API_BASEURL}${url}`
  //判斷BFF路徑
  if(store.getters.IsBFF_MX){ 
    apiUrl = `${BFF_API_BASEURL}/mid-mxf0-crm-ui${commonMixin.methods.convertUri(url)}`
    delete option['x-api-key'];
  }
  
  
  console.log(`Sent[${debugMsg}]Req:${method},url:${apiUrl}`)
  console.log(data)
  
  if (getCookie('api-keys')) {   // 如果 api-key 沒有時不送出 Ajax
    return new Promise((resolve) => {
      axios({
        method: method,
        // url: `${API_PROXY}${API_BASEURL}${url}`,
        url: apiUrl,
        params: method === 'get' ? data : null,
        data: method === 'get' ? null : data,
        headers: option,
        responseType: resType,
        timeout: 60000,
        withCredentials: true,
      })
      .then(response => {
        console.log(`Got[${debugMsg}]Res:${apiUrl}`)
        console.log(response)
        
        if (response.data && response.data.detail && (response.data.detail.loginUrl || response.data.detail.ssoUrl)) {
          localStorage.forcePkmslogout = true;
          deleteCookie('api-keys')
          window.location.reload();
          return;
        }
        
        if (response.data.header && (response.data.header.status == 200 || response.data.header.status == 0)) {
          // return nothing
        }else if (response.data.header && response.data.header.status == 400) {
          console.error(`${debugMsg}異常: `, response.data.header ? response.data.header.message : '')
        } else {
          console.error(`${debugMsg}連線錯誤`)
        }
        resolve(response.data);
      })
      .catch(error => {
        console.error(`Got[${debugMsg}]Res:${apiUrl}`)
        console.error(error);
        let errorData = {
          header:{
            message: "連線逾時 請重新操作",
            status: "400",
            userDeviceIp: "",
            userId: "",
          },
          body:{},
        }
        resolve(errorData);
        // reject(error);
      })
    })
  } else {
    return new Promise((resolve) => {
      console.error(`${debugMsg}:api key 失效 Ajax 不傳送`)
      const errorData = {
        // body: {},
        // header: {
        //   // message: "api key 失效 Ajax 不傳送",
        //   status: "400",
        //   userDeviceIp: "",
        //   userId: "",
        // }
      }
      resolve(errorData)
    })
  }
  
}

export default axiosFormData;